// "Moving most" on the Team page (Carla, 2026-10-21): whose tasks and which clients' tasks had their
// due dates moved most in the last 30 days, each with its tasks, which open in the task drawer. The
// server decides who sees it (Team Pro, and the business's owner or an admin:
// GET /api/tasks/moving-most); anyone else is refused there and this card shows nothing.
import React, { useEffect, useState } from 'react';
import { DashboardCard, StatusPill, Button } from '../../ui';
import { fetchMovingMost } from '../../utils/taskDueChanges';
import { messageFromError } from '../../utils/apiError';
import '../task/overdue.css';

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

function Group({ title, rows, empty, tasks, onOpenTask }) {
  return (
    <div className="ov-moving__group">
      <h3>{title}</h3>
      {rows.length === 0 ? <p className="td-muted">{empty}</p> : (
        <ul className="ov-moving__list">
          {rows.slice(0, 5).map((g) => (
            <li key={g.id} className="ov-moving__item">
              <span className="ov-moving__name"><span>{g.name || 'Former member'}</span><StatusPill tone={g.moves >= 3 ? 'warning' : 'neutral'}>{plural(g.moves, 'move')}</StatusPill></span>
              <span className="ov-moving__tasks">
                {g.tasks.slice(0, 4).map((t) => {
                  const held = tasks.find((x) => String(x.id) === String(t.taskId));
                  const label = `${t.title} (${t.moves}×)`;
                  return held
                    ? <Button key={t.taskId} size="sm" variant="tertiary" onClick={() => onOpenTask(held, [held])}>{label}</Button>
                    : <span key={t.taskId} className="tk-small">{label}</span>;
                })}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default function MovingMostCard({ tasks = [], onOpenTask }) {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let live = true;
    fetchMovingMost()
      .then((d) => { if (live) setState(Array.isArray(d?.byPerson) && Array.isArray(d?.byClient) ? { data: d } : { error: 'Moving most could not be loaded.' }); })
      .catch((e) => { if (live) setState(e?.status === 403 ? { hidden: true } : { error: messageFromError(e, 'Moving most could not be loaded.') }); });
    return () => { live = false; };
  }, []);
  if (state.hidden) return null;
  const d = state.data;
  return (
    <DashboardCard title="Moving most" tint="pastel-peach" data-testid="moving-most"
      meta={<StatusPill tone="neutral">Last 30 days</StatusPill>}>
      {state.loading && <p className="td-muted">Loading…</p>}
      {state.error && <p className="td-muted" role="alert">{state.error}</p>}
      {d && (
        <div className="ov-moving">
          <Group title="By team member" rows={d.byPerson || []} empty="No due dates moved." tasks={tasks} onOpenTask={onOpenTask} />
          <Group title="By client" rows={d.byClient || []} empty="No client's tasks moved." tasks={tasks} onOpenTask={onOpenTask} />
        </div>
      )}
    </DashboardCard>
  );
}
